import React from 'react';

import { Space } from 'antd';
import { HeartFilled, HeartOutlined } from '@ant-design/icons';

import { useClient, useUser } from '../../contexts';

import { LikeProps } from './types';

export const Like: React.FC<LikeProps> = ({
  hasLiked,
  setLikeValues,
  resourceType,
  resourceId,
  color,
  hasText = false,
}) => {
  const { post, deletion } = useClient();
  const { user } = useUser();

  const httpBody = {
    source: {
      id: user?.customer.id,
      model_type: 'customer',
    },
    target: {
      id: resourceId,
      model_type: resourceType,
    },
  };

  const add = () => {
    setLikeValues(1);
    post(
      '/likes',
      httpBody,
      () => {},
      () => {
        /* Rollback change if there is an error */
        setLikeValues(-1);
      }
    );
  };

  const remove = () => {
    setLikeValues(-1);
    deletion(
      '/likes',
      httpBody,
      () => {},
      () => {
        /* Rollback change if there is an error */
        setLikeValues(1);
      }
    );
  };

  const handleLikeClick = () => {
    hasLiked ? remove() : add();
  };

  return (
    <span onClick={() => handleLikeClick()}>
      <Space style={{ cursor: 'pointer' }}>
        {hasLiked ? (
          <HeartFilled
            data-testid="like-heart-filled"
            style={{ color: color }}
          />
        ) : (
          <HeartOutlined style={{ color: color }} />
        )}
        {hasText && `J'aime`}
      </Space>
    </span>
  );
};
